export default {
    facility: 'facility',
    individual: 'individual'
}